import {
    Button,
    Dialog,
    DialogContent,
    DialogTrigger,
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@repo/shadcn';
import { CellContext, ColumnDef } from '@tanstack/react-table';
import { ChevronDownIcon, Loader2Icon, Trash } from 'lucide-react';
import { toast } from 'sonner';

import { ButtonGroup } from '@components/ui/button';

import { toastError } from '@/utils';

import {
    useDeleteTypeMutation,
    useEditTypeMutation,
} from '../../../../features/slice/products/type/type-api-slice';
import { TypeForm } from '../type-form.component';

const ActionCell = ({ row }: CellContext<any, unknown>) => {
    const [deleteType, { isLoading: isDeleting }] = useDeleteTypeMutation();
    const [editType, { isLoading: isEditing }] = useEditTypeMutation();

    const handleDeleteType = async (typeId: string) => {
        const confirmed = window.confirm(
            'Are you sure you want to delete this type  ?',
        );
        if (!confirmed) return;

        try {
            await deleteType(typeId).unwrap();
            toast.success('Type has been deleted');
        } catch (error) {
            toastError(
                error,
                'useTypeList: handleDeleteType -> Failed to delete type.',
            );
        }
    };

    const handleEdit = async (data: any) => {
        try {
            await editType({
                id: row.original.id,
                name: data.name,
            }).unwrap();
            toast.success('Type has been updated');
        } catch (error) {
            toastError(error, 'Failed to edit type.');
        }
    };

    return (
        <div className={'flex justify-end'}>
            <ButtonGroup>
                <Dialog>
                    <DialogTrigger>
                        <Button type={'button'} variant={'outline'}>
                            Edit
                        </Button>
                    </DialogTrigger>
                    <DialogContent>
                        <TypeForm
                            initialValues={{
                                name: row.original.name,
                            }}
                            onSubmit={handleEdit}
                            title="Edit Type"
                            isLoading={isEditing}
                        />
                    </DialogContent>
                </Dialog>
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button variant="outline" className="!pl-2">
                            <ChevronDownIcon />
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                        align="end"
                        className="[--radius:1rem]"
                    >
                        <DropdownMenuGroup>
                            <DropdownMenuItem
                                className={'flex gap-2 text-destructive'}
                                onClick={() =>
                                    handleDeleteType(row.original.id)
                                }
                            >
                                {isDeleting ? (
                                    <Loader2Icon className={'animate-spin'} />
                                ) : (
                                    <>
                                        <Trash className={'size-4'} />
                                        Delete
                                    </>
                                )}
                            </DropdownMenuItem>
                        </DropdownMenuGroup>
                    </DropdownMenuContent>
                </DropdownMenu>
            </ButtonGroup>
        </div>
    );
};

export const typeListColumns: ColumnDef<any>[] = [
    {
        accessorKey: 'name',
        header: 'Name',
        cell: ({ row }) => {
            return (
                <div
                    title={row.getValue('name')}
                    // className=" w-[200px] cursor-pointer truncate"
                >
                    {row.getValue('name')}
                </div>
            );
        },
    },

    {
        accessorKey: 'actions',
        header: () => <div className="text-right">Actions</div>,
        cell: ActionCell,
    },
];
